import { Routes, Route } from 'react-router-dom'

import { Layout } from '../dashboard/layout/Layout'
import { ForgotPassword } from '../auth/forgotPassword/ForgotPassword'
import { SetPassword } from '../auth/setPassword/SetPassword'
import { SignIn } from '../auth/signIn/SignIn'
import { SignInWithRecoveryCodeContainer } from '../auth/signIn/TwoFactorAuthentication/SignInWithRecoveryCode/SignInWithRecoveryCodeContainer'
import { SignWithTwoFA } from '../auth/signIn/TwoFactorAuthentication/SignInWithTwoFA/SignWithTwoFA'
import { SSO } from '../auth/sso/SSO'
import { ExpiredSessionHandleContainer } from '../auth/expiredSessionHandleContainer/ExpiredSessionHandleContainer'
import { SSOGateway } from '../auth/sso/SSOGateway'

import { TwoFactorAuthenticationSetup } from '@percent/partner-dashboard/app/auth/signIn/TwoFactorAuthentication/TwoFactorAuthenticationSetup'
import { AuthorisedRoute } from '@percent/partner-dashboard/app/auth/authorisedRoute/AuthorisedRoute'

export function AppRoutes() {
  return (
    <>
      <Routes>
        <Route element={<TwoFactorAuthenticationSetup />} path="/2fa-setup" />
        <Route path="/signin/2fa-recovery" element={<SignInWithRecoveryCodeContainer />} />
        <Route path="/signin/2fa" element={<SignWithTwoFA />} />
        <Route path="/signin/sso/gateway" element={<SSOGateway />} />
        <Route path="/signin/sso" element={<SSO />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/expired-session" element={<ExpiredSessionHandleContainer />} />
        <Route path="/*" element={<AuthorisedRoute element={<Layout />} />} />
      </Routes>
    </>
  )
}
